import type { PageProps } from "@/types";
import type { InvestorPageProps } from "@/types/pages/investor";
import type { FC } from "react";
import { InvestorTitle, InvestorDescription, InvestorExample, InvestorAppreciation, InstitutionalInvestors, IndividualInvestors, InterestedInInvesting, InvestorLatestInsights } from "../investor";
import { LeadInvestor } from "../investor/lead-investor";

export const Investor: FC<PageProps<InvestorPageProps>> = (props) => {
    return <div>
        <InvestorTitle 
            label={props.meta.translation.investor.title}
            title={props.data.title}
        />
        <InvestorDescription 
            description={props.data.payallFoundation}
        />
        <InvestorExample
            content={props.data.investorsExample}
        />
        <InvestorAppreciation
            cols={props.data.investorsAppreciation}
        />
        <LeadInvestor
            title={props.data.leadInvestor}
            image={props.data.leadInvestorName}
        />
        {props.data.latestInsights?.length > 0 && (
        <InvestorLatestInsights
          title={props.meta.translation.investor.latestInsights.title}
          viewAll={props.meta.translation.investor.latestInsights.viewAll}
          readMore={props.meta.translation.investor.latestInsights.readMore}
          posts={props.data.latestInsights}
        />
      )}
        <InstitutionalInvestors 
            title={props.data.institutionalInvestors}
            logos={props.data.institutionalInvestorsLogos}
        />
        <IndividualInvestors
            title={props.data.individualInvestors}
            investors={props.data.individualInvestorsNames}
        />
    </div>
}